import { FormControl, MenuItem, Select, Stack, useTheme } from "@mui/material";
import { useContext, useEffect } from "react";
import LoadingComponent from "src/components/ui/loading-component/LoadingComponent";
import { Graduated } from "src/components/ui/svgIcon/Graduated";
import { UserContext } from "src/contexts/UserContext";
import useActiveSiteList from "src/layouts/AVC_Main/services/headerDashboard/useActiveSiteList";

const SiteListItem = () => {
  const theme = useTheme();
  const { data, loading: listLoading } = useActiveSiteList();
  const { setBusinessID, setBusinessName, setBusinessCircle, setUniqueIdentifier, setBusinessCircles } =
    useContext(UserContext);
  useEffect(() => {
    if (data?.activeSiteList?.edges?.length) {
      setBusinessID(data?.activeSiteList?.edges[0].node?.id);
      setBusinessName(data?.activeSiteList?.edges[0].node?.name);
      setBusinessCircle(data?.activeSiteList?.edges[0].node?.chain?.standardCode);
      setBusinessCircles(data?.activeSiteList?.edges[0].node?.chains?.edges.map((chain) => +chain.node.standardCode));
      setUniqueIdentifier(data?.activeSiteList?.edges[0].node?.uniqueIdentifier);
    }
  }, [data]);

  const handleChange = (event) => {
    setBusinessID(event.target.value?.id);
    setBusinessName(event.target.value?.name);
    setBusinessCircle(data?.activeSiteList?.edges[0].node?.chain?.standardCode);
    setBusinessCircles(event.target.value.chains?.edges.map((chain) => +chain.node.standardCode));
    setUniqueIdentifier(event.target.value?.uniqueIdentifier);
  };

  return (
    <Stack direction="row" justifyContent="center" alignItems="center">
      <Graduated color={theme.palette.primary.main} />
      <FormControl variant="outlined" fullWidth>
        <LoadingComponent open={listLoading} />
        {data?.activeSiteList?.edges?.length ? (
          <Select
            defaultValue={data?.activeSiteList?.edges[0]?.node}
            autoWidth
            sx={{
              width: 280,
              padding: "2px !important",
              borderRadius: "8px !important",
              "& .MuiOutlinedInput-input": {
                padding: "2px 12px !important",
              },
            }}
            onChange={handleChange}
            MenuProps={{
              PaperProps: {
                sx: {
                  boxShadow: "none !important",
                  background: theme.palette.grey.g7,
                  borderRadius: "0 0  8px 8px !important",
                },
              },
            }}
          >
            {data?.activeSiteList?.edges?.map((option) => {
              return (
                <MenuItem style={{ whiteSpace: "normal", width: 280 }} value={option?.node} key={option?.node?.id}>
                  {option.node.name}
                </MenuItem>
              );
            })}
          </Select>
        ) : null}
      </FormControl>
    </Stack>
  );
};

export default SiteListItem;
